/**
 * PostHog Event Name Constants and Mappings
 */

// Event names following pattern: [entity]:[category]:[action]
export const POSTHOG_EVENTS = {
  // Office Authentication Events
  OFFICE_AUTH_LOGIN_INITIATED: 'office:auth:login_initiated',
  OFFICE_AUTH_LOGIN_SUCCESS: 'office:auth:login_success',
  OFFICE_AUTH_LOGIN_FAILED: 'office:auth:login_failed',
  OFFICE_AUTH_LOGOUT: 'office:auth:logout',
  OFFICE_AUTH_SESSION_EXPIRED: 'office:auth:session_expired',

  // Office Logout Events
  OFFICE_LOGOUT_CLICKED: 'office:logout:clicked',
  OFFICE_LOGOUT_CONFIRMED: 'office:logout:confirmed',

  // Office Account Events
  OFFICE_ACCOUNT_UPDATED: 'office:account:updated',
  OFFICE_NOTIFICATION_TOGGLED: 'office:notification:toggled',
  OFFICE_FEEDBACK_SUBMITTED: 'office:feedback:submitted',

  // Office Calendar Events
  OFFICE_CALENDAR_NEXT_MONTH_CLICKED: 'office:calendar:next_month_clicked',
  OFFICE_CALENDAR_PREVIOUS_MONTH_CLICKED: 'office:calendar:previous_month_clicked',
  OFFICE_CALENDAR_POST_SHIFT_CLICKED: 'office:calendar:post_shift_clicked',
  OFFICE_CALENDAR_VIEW_SHIFT_DETAILS: 'office:calendar:view_shift_details',

  // Office Shift Events
  OFFICE_SHIFT_REQUEST_SUBMITTED: 'office:shift:request_submitted',

  // Office Login Events
  OFFICE_LOGIN_FORGOT_PASSWORD_CLICKED: 'office:login:forgot_password_clicked',
  OFFICE_LOGIN_LOGIN_TAB_CLICKED: 'office:login:login_tab_clicked',
  OFFICE_LOGIN_SIGNUP_TAB_CLICKED: 'office:login:signup_tab_clicked',

  // Office Signup Events
  OFFICE_SIGNUP_CLICKED: 'office:signup:clicked',
  OFFICE_SIGNUP_FORM_SUBMITTED: 'office:signup:form_submitted',
  OFFICE_SIGNUP_VERIFICATION_SUBMITTED: 'office:signup:verification_submitted',

  // Office Password Reset Events
  OFFICE_RESET_PASSWORD_CODE_REQUESTED: 'office:reset_password:code_requested',

  // Office Invite Event - Single event with properties for source tracking
  OFFICE_INVITE_SENT: 'office:invite:sent',

  // Navigation Events
  NAV_PAGE_VIEWED: 'app:navigation:page_viewed',

  // Error Events
  ERROR_BOUNDARY_TRIGGERED: 'app:error:boundary_triggered',
} as const;

// Map Redux action types to PostHog events
export const REDUX_TO_POSTHOG_EVENT_MAP: Record<string, string> = {
  // Authentication mappings
  'LOGIN_REQUEST': POSTHOG_EVENTS.OFFICE_AUTH_LOGIN_INITIATED,
  'LOGIN_SUCCESS': POSTHOG_EVENTS.OFFICE_AUTH_LOGIN_SUCCESS,
  'LOGIN_FAILURE': POSTHOG_EVENTS.OFFICE_AUTH_LOGIN_FAILED,
  'LOGOUT': POSTHOG_EVENTS.OFFICE_AUTH_LOGOUT,
  'LOGOUT_SUCCESS': POSTHOG_EVENTS.OFFICE_AUTH_LOGOUT,
};

export type PosthogEventName = typeof POSTHOG_EVENTS[keyof typeof POSTHOG_EVENTS];